import { useTranslation } from 'react-i18next';
import cx from 'classnames';

import { Button } from '@/components/Button';
import { SvgIcon } from '@/components/SvgIcon';
import { TariffBadge } from '@/components/TariffBadge';
import { CompareReportsModal } from '@/components/_modals';
import { PlanCategoryEnum } from '@/config';
import { useModal } from '@/hooks/useModal';

import styles from './RiskDetailsUnlock.module.sass';

interface RiskDetailsUnlockProps {
  className?: string;
}

const RiskDetailsUnlock = ({ className }: RiskDetailsUnlockProps) => {
  const { t } = useTranslation();
  const {
    isOpen: isOpenCompareReportsModal,
    onOpenModal: handleOpenCompareReportsModal,
    onCloseModal: handleCloseCompareReportsModal,
  } = useModal();

  const classes = cx(styles.unlock, className);

  return (
    <>
      <div className={classes}>
        <div className={styles.icon}>
          <SvgIcon name="lock-filled" />
        </div>

        <div className={styles.title}>
          {t('translation.risk_detailes_unlock.title')}
          <TariffBadge
            tariff={PlanCategoryEnum.PRO_PLUS}
            className={styles.badge}
          />
        </div>

        <div className={styles.description}>
          {t('translation.risk_detailes_unlock.description')}
        </div>

        <Button
          type="primary-black"
          size="s"
          corner="rect"
          className={styles.button}
          onClick={handleOpenCompareReportsModal}
        >
          {t('translation.risk_detailes_unlock.upgrade_to_pro_plus')}
        </Button>
      </div>

      <CompareReportsModal
        isOpen={isOpenCompareReportsModal}
        onClose={handleCloseCompareReportsModal}
      />
    </>
  );
};

export default RiskDetailsUnlock;
